/**
 * Mobile touch enhancements for Florida's Scenic Byways
 * Improves touch interactions for route elements
 */

document.addEventListener('DOMContentLoaded', function () {
	// Check if we're on a touch device
	if ('ontouchstart' in window || navigator.maxTouchPoints) {
		document.body.classList.add('touch-device');

		// Find all route items and enhance their touch behavior
		enhanceRouteTouchTargets();

		// Add touch feedback behaviors
		addTouchFeedback();
	}
});

/**
 * Enhances route items to be more touch-friendly
 */
function enhanceRouteTouchTargets() {
	// Find all route items
	const routeItems = document.querySelectorAll('.route-item, .byway-link, .clickable-element');

	routeItems.forEach(item => {
		// Add touch-specific class
		item.classList.add('touch-target');

		// Ensure the entire element is clickable
		const mainLink = item.querySelector('a');
		if (mainLink && !mainLink.classList.contains('touch-enhanced')) {
			// Create a new element that covers the entire route item
			mainLink.classList.add('touch-enhanced');

			// Stop touch events from firing multiple times
			item.addEventListener('touchend', function (e) {
				// If this item has a link, let the link handle the navigation
				if (mainLink && e.target !== mainLink) {
					e.preventDefault();
					// Slight delay to allow the visual feedback to show
					setTimeout(() => {
						mainLink.click();
					}, 100);
				}
			});
		}
	});
}

/**
 * Adds visual feedback for touch events
 */
function addTouchFeedback() {
	const touchTargets = document.querySelectorAll('.touch-target, button, .nav-link');

	touchTargets.forEach(target => {
		// Add touch start feedback
		target.addEventListener('touchstart', function () {
			this.classList.add('touch-active');
		}, { passive: true });

		// Remove the feedback on touch end
		target.addEventListener('touchend', function () {
			this.classList.remove('touch-active');
		}, { passive: true });

		// Also remove on touch move (user might change their mind)
		target.addEventListener('touchmove', function () {
			this.classList.remove('touch-active');
		}, { passive: true });

		// Remove after a timeout (in case the event doesn't fire)
		target.addEventListener('touchstart', function () {
			const element = this;
			setTimeout(function () {
				element.classList.remove('touch-active');
			}, 300);
		}, { passive: true });
	});
}

// If there's a map, enhance its touch behavior
function enhanceMapTouchBehavior() {
	// Check if a map instance exists
	if (window.map) {
		// If using Leaflet maps, adjust touch behavior
		if (window.L) {
			// Increase tolerance for tap detection
			if (window.map.tap) {
				window.map.tap.options.tolerance = 15;
			}
		}
	}
}

// Expose these functions globally
window.mobileTouch = {
	enhanceRouteTouchTargets,
	addTouchFeedback,
	enhanceMapTouchBehavior
};
